(function ($) {
	
	if ($('body').hasClass('ie-edge')) {
		var img = $('.object-fit-image, .object-fit-image img');
		window.objectFitImages(img);
	}

})(jQuery);
